import NProgress from "nprogress";
import "nprogress/nprogress.css";

// 进度条配置;
NProgress.configure({
  showSpinner: false, // 关闭右上角loading转圈动画;
});

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.$router.beforeEach((to, from, next) => {
    NProgress.start();
    next();
  });
  // ;
  nuxtApp.$router.afterEach(() => {
    NProgress.done();
  });
});
